// @flow
export const getFlag = (alpha3?: string) => {
  if (!alpha3) return FLAGS['default'];
  const lowerAlpha3 = alpha3.toLowerCase();
  return FLAGS[lowerAlpha3];
};

const FLAGS = {
  default: require('./gifs/default-flag.gif'),
  afg: require('./pngs/afg.png'),
  usaak: require('./pngs/usa.png'),
  alb: require('./pngs/alb.png'),
  and: require('./pngs/and.png'),
  ago: require('./pngs/ago.png'),
  aia: require('./pngs/aia.png'),
  atg: require('./pngs/atg.png'),
  arg: require('./pngs/arg.png'),
  arm: require('./pngs/arm.png'),
  abw: require('./pngs/abw.png'),
  aus: require('./pngs/aus.png'),
  aust: require('./pngs/aus.png'),
  aut: require('./pngs/aut.png'),
  aze: require('./pngs/aze.png'),
  bes: require('./pngs/bes.png'),
  bhs: require('./pngs/bhs.png'),
  bhr: require('./pngs/bhr.png'),
  bgd: require('./pngs/bgd.png'),
  brb: require('./pngs/brb.png'),
  bel: require('./pngs/bel.png'),
  bmu: require('./pngs/bmu.png'),
  blr: require('./pngs/blr.png'),
  blz: require('./pngs/blz.png'),
  ben: require('./pngs/ben.png'),
  btn: require('./pngs/btn.png'),
  bol: require('./pngs/bol.png'),
  bih: require('./pngs/bih.png'),
  bwa: require('./pngs/bwa.png'),
  bra: require('./pngs/bra.png'),
  brn: require('./pngs/brn.png'),
  bgr: require('./pngs/bgr.png'),
  bfa: require('./pngs/bfa.png'),
  mmr: require('./pngs/mmr.png'),
  bdi: require('./pngs/bdi.png'),
  khm: require('./pngs/khm.png'),
  cmr: require('./pngs/cmr.png'),
  can: require('./pngs/can.png'),
  civ: require('./pngs/civ.png'),
  chl: require('./pngs/chl.png'),
  chn: require('./pngs/chn.png'),
  cym: require('./pngs/cym.png'),
  cxr: require('./pngs/cxr.png'),
  cck: require('./pngs/cck.png'),
  col: require('./pngs/col.png'),
  com: require('./pngs/com.png'),
  cri: require('./pngs/cri.png'),
  cub: require('./pngs/cub.png'),
  hrv: require('./pngs/hrv.png'),
  cyp: require('./pngs/cyp.png'),
  cze: require('./pngs/cze.png'),
  cod: require('./pngs/cod.png'),
  dnk: require('./pngs/dnk.png'),
  dji: require('./pngs/dji.png'),
  dom: require('./pngs/dom.png'),
  dma: require('./pngs/dma.png'),
  dza: require('./pngs/dza.png'),
  tls: require('./pngs/tls.png'),
  ecu: require('./pngs/ecu.png'),
  egy: require('./pngs/egy.png'),
  gnq: require('./pngs/gnq.png'),
  eri: require('./pngs/eri.png'),
  est: require('./pngs/est.png'),
  eth: require('./pngs/eth.png'),
  fro: require('./pngs/fro.png'),
  fji: require('./pngs/fji.png'),
  fin: require('./pngs/fin.png'),
  fra: require('./pngs/fra.png'),
  pyf: require('./pngs/pyf.png'),
  gab: require('./pngs/gab.png'),
  gmb: require('./pngs/gmb.png'),
  geo: require('./pngs/geo.png'),
  gum: require('./pngs/gum.png'),
  deu: require('./pngs/deu.png'),
  gha: require('./pngs/gha.png'),
  gib: require('./pngs/gib.png'),
  grc: require('./pngs/grc.png'),
  grl: require('./pngs/grl.png'),
  cpv: require('./pngs/cpv.png'),
  grd: require('./pngs/grd.png'),
  glp: require('./pngs/glp.png'),
  gtm: require('./pngs/gtm.png'),
  gin: require('./pngs/gin.png'),
  gnb: require('./pngs/gnb.png'),
  guy: require('./pngs/guy.png'),
  hti: require('./pngs/hti.png'),
  hnd: require('./pngs/hnd.png'),
  hkg: require('./pngs/hkg.png'),
  hun: require('./pngs/hun.png'),
  iodg: require('./pngs/iodg.png'),
  isl: require('./pngs/isl.png'),
  ind: require('./pngs/ind.png'),
  idn: require('./pngs/idn.png'),
  irn: require('./pngs/irn.png'),
  irq: require('./pngs/irq.png'),
  irl: require('./pngs/irl.png'),
  isr: require('./pngs/isr.png'),
  ita: require('./pngs/ita.png'),
  jam: require('./pngs/jam.png'),
  jpn: require('./pngs/jpn.png'),
  jor: require('./pngs/jor.png'),
  kaz: require('./pngs/kaz.png'),
  ken: require('./pngs/ken.png'),
  kwt: require('./pngs/kwt.png'),
  kgz: require('./pngs/kgz.png'),
  lao: require('./pngs/lao.png'),
  lva: require('./pngs/lva.png'),
  lbn: require('./pngs/lbn.png'),
  lso: require('./pngs/lso.png'),
  lbr: require('./pngs/lbr.png'),
  lby: require('./pngs/lby.png'),
  lie: require('./pngs/lie.png'),
  ltu: require('./pngs/ltu.png'),
  lux: require('./pngs/lux.png'),
  mac: require('./pngs/mac.png'),
  mdg: require('./pngs/mdg.png'),
  mkd: require('./pngs/mkd.png'),
  mwi: require('./pngs/mwi.png'),
  mli: require('./pngs/mli.png'),
  mlt: require('./pngs/mlt.png'),
  mhl: require('./pngs/mhl.png'),
  mus: require('./pngs/mus.png'),
  mrt: require('./pngs/mrt.png'),
  myt: require('./pngs/myt.png'),
  mex: require('./pngs/mex.png'),
  fsm: require('./pngs/fsm.png'),
  mco: require('./pngs/mco.png'),
  mng: require('./pngs/mng.png'),
  mne: require('./pngs/mne.png'),
  msr: require('./pngs/msr.png'),
  mar: require('./pngs/mar.png'),
  moz: require('./pngs/moz.png'),
  nam: require('./pngs/nam.png'),
  npl: require('./pngs/npl.png'),
  nld: require('./pngs/nld.png'),
  sxm: require('./pngs/sxm.png'),
  ant: require('./pngs/ant.png'),
  asm: require('./pngs/asm.png'),
  ncl: require('./pngs/ncl.png'),
  nic: require('./pngs/nic.png'),
  nru: require('./pngs/nru.png'),
  nzl: require('./pngs/nzl.png'),
  ner: require('./pngs/ner.png'),
  nga: require('./pngs/nga.png'),
  prk: require('./pngs/prk.png'),
  mnp: require('./pngs/mnp.png'),
  mtq: require('./pngs/mtq.png'),
  nor: require('./pngs/nor.png'),
  omn: require('./pngs/omn.png'),
  pak: require('./pngs/pak.png'),
  plw: require('./pngs/plw.png'),
  pse: require('./pngs/pse.png'),
  pan: require('./pngs/pan.png'),
  pry: require('./pngs/pry.png'),
  per: require('./pngs/per.png'),
  phl: require('./pngs/phl.png'),
  pol: require('./pngs/pol.png'),
  pri: require('./pngs/pri.png'),
  prt: require('./pngs/prt.png'),
  qat: require('./pngs/qat.png'),
  cog: require('./pngs/cog.png'),
  rou: require('./pngs/rou.png'),
  rus: require('./pngs/rus.png'),
  rwa: require('./pngs/rwa.png'),
  kna: require('./pngs/kna.png'),
  vct: require('./pngs/vct.png'),
  slv: require('./pngs/slv.png'),
  smr: require('./pngs/smr.png'),
  sau: require('./pngs/sau.png'),
  sen: require('./pngs/sen.png'),
  srb: require('./pngs/srb.png'),
  sle: require('./pngs/sle.png'),
  sgp: require('./pngs/sgp.png'),
  svk: require('./pngs/svk.png'),
  svn: require('./pngs/svn.png'),
  som: require('./pngs/som.png'),
  zaf: require('./pngs/zaf.png'),
  kor: require('./pngs/kor.png'),
  esp: require('./pngs/esp.png'),
  lka: require('./pngs/lka.png'),
  lca: require('./pngs/lca.png'),
  spm: require('./pngs/spm.png'),
  sdn: require('./pngs/sdn.png'),
  ssd: require('./pngs/ssd.png'),
  stma: require('./pngs/stma.png'),
  sur: require('./pngs/sur.png'),
  swz: require('./pngs/swz.png'),
  swe: require('./pngs/swe.png'),
  che: require('./pngs/che.png'),
  syc: require('./pngs/syc.png'),
  syr: require('./pngs/syr.png'),
  tata: require('./gifs/tata.gif'),
  twn: require('./pngs/twn.png'),
  tjk: require('./pngs/tjk.png'),
  tha: require('./pngs/tha.png'),
  tgo: require('./pngs/tgo.png'),
  ton: require('./pngs/ton.png'),
  tto: require('./pngs/tto.png'),
  tur: require('./pngs/tur.png'),
  tkm: require('./pngs/tkm.png'),
  tca: require('./pngs/tca.png'),
  tzn: require('./pngs/tzn.png'),
  uga: require('./pngs/uga.png'),
  gbr: require('./pngs/gbr.png'),
  ukr: require('./pngs/ukr.png'),
  are: require('./pngs/are.png'),
  usa: require('./pngs/usa.png'),
  usahi: require('./pngs/usa.png'),
  ury: require('./pngs/ury.png'),
  uzb: require('./pngs/uzb.png'),
  ven: require('./pngs/ven.png'),
  vnm: require('./pngs/vnm.png'),
  vir: require('./pngs/vir.png'),
  vgb: require('./pngs/vgb.png'),
  yem: require('./pngs/yem.png'),
  wlf: require('./pngs/wlf.png'),
  zmb: require('./pngs/zmb.png'),
  zwe: require('./pngs/zwe.png'),
  vut: require('./pngs/vut.png'),
  png: require('./pngs/png.png'),
  wsm: require('./pngs/wsm.png'),
};
